/**
 * All application resume form storage will be defined here.
 *
 * @var const storage
 */
export const storage = {
    form: {},
};